import toast from 'react-hot-toast';
import { Info } from 'lucide-react';

export function toastPendingReviewInfo(message: string) {
  toast(message, {
    duration: 5000,
    icon: <Info className="h-5 w-5 shrink-0 text-[#A0A0A4]" aria-hidden />,
  });
}
